import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLConfig } from '../../configurations/url-config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BalanceSheetService {
  constructor(private http: HttpClient) {}

  getBranchesList() {
    let user: any = JSON.parse(localStorage.getItem('user') as string);
    const params = { branchIds: user?.branchIds.join(',') };
    let agentTellerId = localStorage.getItem('tellerKey');
    let headers = new HttpHeaders();
    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }
    return this.http.get(URLConfig.monthlyStatementBranchesList, {
      params,
      headers,
    });
  }

  getStatement(params: {}): Observable<Blob> {
    return this.http.get(URLConfig.accountBranchStatement, {
      params,
      responseType: 'blob',
    });
  }

  getAgentList(branchIds: string) {
    const params = { branchIds };
    return this.http.get(URLConfig.monthlyStatementAgentsList, { params });
  }

  getTellerKeyDetails(): Observable<any> {
    let agentTellerId = localStorage.getItem('tellerKey');
    let headers = new HttpHeaders();
    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }

    return this.http.get(URLConfig.tellerKeyDetails, { headers });
  }

  getGeneratedPublicAndPrivateKey(): Observable<Blob> {
    let agentTellerId = localStorage.getItem('tellerKey');
    let headers = new HttpHeaders();

    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }

    return this.http.post(
      URLConfig.generatePrivateKey,
      {},
      {
        headers: headers,
        responseType: 'blob',
      },
    );
  }

  getResetTellerKey(): Observable<any> {
    const agentTellerId = localStorage.getItem('tellerKey');
    let headers = new HttpHeaders();

    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }

    // POST request with an empty body
    return this.http.post(URLConfig.resetTellerKey, {}, { headers });
  }

  loadPublicKey(publicKey: string): Observable<any> {
    const agentTellerId = localStorage.getItem('tellerKey');
    const user: any = JSON.parse(localStorage.getItem('user') as string);

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if (agentTellerId) {
      headers = headers.set('x-neobank-agent-teller-id', agentTellerId);
    }

    const params = {
      userId: user?.managerUserKey,
    };

    const body = {
      parterPubKey: publicKey, 
    };

    return this.http.post(URLConfig.loadPublicKey, body, {
      params,
      headers,
    });
  }
}
